export default __webpack_public_path__ + "static/media/ironhide.7fc7636f.png";